import React, { useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from '../src/pages/home';
import QuemSomos from '../src/pages/quemsomos';
import Academias from '../src/pages/academias';
import MateriaisDeEstudo from '../src/pages/materiais-de-estudo';
import Eventos from './pages/eventos';
import EventosPassados from './pages/eventos-passados';
import Evento from './pages/evento';
import Exames from './pages/exames';
import Exame from './pages/exame';
import CursosSeminarios from './pages/cursos-seminarios';
import EventoInscricao from './pages/evento-inscricao';
import Noticias from '../src/pages/noticias';
import Noticia from '../src/pages/noticia';
import Login from '../src/pages/login';
import PainelAluno from './pages/meu-painel';
import Documentos from '../src/pages/documentos';
import CadastrarAcademia from '../src/pages/cadastrar-academia';
import CadastrarAtleta from '../src/pages/cadastrar-atleta';
import Ranking from './pages/ranking';
//import Contato from './pages/contato';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const routes = [
  { path: '/', element: <Home /> },
  { path: '/quem-somos', element: <QuemSomos /> },
  { path: '/academias', element: <Academias /> },
  { path: '/materiais-de-estudo', element: <MateriaisDeEstudo /> },
  { path: '/eventos', element: <Eventos /> },
  { path: '/eventos-passados', element: <EventosPassados /> },
  { path: '/evento/:slug', element: <Evento /> },
  { path: '/evento-inscricao/:slug', element: <EventoInscricao /> },
  { path: '/exames', element: <Exames /> },
  { path: '/exame/:slug', element: <Exame /> },
  { path: '/noticias', element: <Noticias /> },
  { path: '/noticia/:slug', element: <Noticia /> },
  { path: '/login', element: <Login /> },
  { path: '/meu-painel', element: <PainelAluno   /> },
  { path: '/documentos/:slug', element: <Documentos /> },
  { path: '/cursos-seminarios', element: <CursosSeminarios /> },
  { path: '/cadastrar-academia', element: <CadastrarAcademia /> },
  { path: '/cadastrar-atleta', element: <CadastrarAtleta /> },
  { path: '/cadastrar-atleta/:slug', element: <CadastrarAtleta /> },
  { path: '/ranking', element: <Ranking /> },
  //{ path: '/contato', element: <Contato /> },
];

const Navigation = () => (
  <Routes>
    {routes.map(({ path, element }) => (
      <Route key={path} path={path} element={element} />
    ))}
  </Routes>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <HelmetProvider>
          <ScrollToTop />
          <Navigation />
        </HelmetProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
